import * as R from 'ramda';

const renderGroup = () => R.identity;

export default renderGroup;
